export function normalizeHexColor(color) {
    if (!color) return '#000000';
    return color.startsWith('#') ? color : `#${color}`;
}

const COLOR_BUCKETS = [
    '#aec7e8',
    '#ff7f0e',
    '#ffbb78',
    '#2ca02c',
    '#98df8a',
    '#d62728',
    '#ff9896',
    '#9467bd',
    '#c5b0d5',
    '#8c564b',
    '#c49c94',
    '#e377c2',
    '#f7b6d2',
    '#7f7f7f',
    '#c7c7c7',
    '#bcbd22',
    '#dbdb8d',
    '#17becf',
    '#9edae5',
    '#1f77b4',
];

const NON_BOOKABLE_COLOR = '#e0e0e0';
const RESERVED_COLOR = '#bdbdbd';
const SUGGESTED_COLOR = '#fb8c00';
const SELECTED_COLOR = '#ffff00';
const CROSS_TYPE_COLOR = '#d32f2f'; // MUI error.main — reserved mismatch seats
const CROSS_TYPE_SELECTED_COLOR = '#ef5350'; // MUI error.light — selected mismatch seats

function parseTicketTypeColor(ticketType, fallback) {
    if (!ticketType.color) return fallback;
    const raw = ticketType.color.trim();
    if (/^#([0-9A-F]{3}){1,2}$/i.test(raw)) return raw;
    if (/^([0-9A-F]{3}){1,2}$/i.test(raw)) return `#${raw}`;
    return fallback;
}

export function computeSeatColorMap({
    elements,
    ticketTypes,
    selectedDraftSeatIdSet,
    suggestedSeatIds,
    reservedByOtherSeatIdSet,
    freeSeatIds,
    currentGroupSavedSeatIdSet,
    crossTypeMismatchSeatIds,
}) {
    const colorMap = {};
    const ticketTypeColorMap = {};
    const suggestedSet = new Set(suggestedSeatIds);

    const seatToColor = {};
    (ticketTypes || []).forEach((tt, i) => {
        const bucketColor = COLOR_BUCKETS[i % COLOR_BUCKETS.length];
        const ttColor = parseTicketTypeColor(tt, bucketColor);
        if (Array.isArray(tt.seats) && tt.seats.length > 0) {
            ticketTypeColorMap[tt.name] = ttColor;
            tt.seats.forEach((seat) => {
                seatToColor[seat.id] = ttColor;
            });
        }
    });

    (elements || []).forEach((el) => {
        if (!el.bookable) {
            colorMap[el.id] = NON_BOOKABLE_COLOR;
            return;
        }
        if (selectedDraftSeatIdSet.has(el.id)) {
            colorMap[el.id] = crossTypeMismatchSeatIds?.has(el.id)
                ? CROSS_TYPE_SELECTED_COLOR
                : SELECTED_COLOR;
            return;
        }
        if (suggestedSet.has(el.id)) {
            colorMap[el.id] = SUGGESTED_COLOR;
            return;
        }
        if (
            reservedByOtherSeatIdSet.has(el.id) ||
            (!freeSeatIds.has(el.id) && !currentGroupSavedSeatIdSet?.has(el.id))
        ) {
            colorMap[el.id] = crossTypeMismatchSeatIds?.has(el.id)
                ? CROSS_TYPE_COLOR
                : RESERVED_COLOR;
            return;
        }
        colorMap[el.id] = seatToColor[el.id] || COLOR_BUCKETS[0];
    });

    return { colorMap, ticketTypeColorMap };
}
